
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.727 1.31L1.698 4.34m8.862-3.03l-8.75 8.75m14.584 2.917l-3.029 3.03m3.029-8.863l-8.75 8.75m8.75-14.584L1.81 15.894","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    